import { render, staticRenderFns } from "./h-sponsor-page.vue?vue&type=template&id=46f41115&"
import script from "./h-sponsor-page.vue?vue&type=script&lang=js&"
export * from "./h-sponsor-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports